<template>
  {{ count }}
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'

import { useCountdown } from '../../composables/useCountdown'

export default defineComponent({
  props: {
    from: {
      type: Number,
      required: true,
    },
  },
  emits: {
    timeout: () => true,
    count: (_time: number) => true,
  },
  setup(props, { emit }) {
    const count = useCountdown(props.from)
    watch(count, (count) => {
      emit('count', count)
      if (count <= 0) emit('timeout')
    })
    return { count }
  },
})
</script>
